// a *really* basic event emitter

export default function Emitter() {
  const map = new Map();

  return {
    on(name, fn) {
      if (!map.has(name)) {
        map.set(name, new Set());
      }

      const set = map.get(name);

      set.add(fn);

      return () => set.delete(fn);
    },

    emit(name, event) {
      if (!map.has(name)) return;

      for (const fn of map.get(name).values()) {
        fn(event);
      }
    },
  };
};